import styled from "styled-components";
import backgroundImage from "../../images/loginImage.png";

export const LoginStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;

  .left {
    padding: 30px;
    .content {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;

      .internal-flex {
        margin-top: -80px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .right {
    width: 100%;
    height: 100%;
    background-image: url(${backgroundImage});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
`;
